document.addEventListener("DOMContentLoaded", function () {
	// SHOW / HIDE MOBILE MENU

	function initBurgerMenu() {
		const burger = document.querySelector(".js_hamburger");
		const nav = document.querySelector(".js_mob_menu");
		if (!burger || !nav) return;

		burger.addEventListener("click", function () {
			burger.classList.toggle("is-active");
			nav.classList.toggle("open");
			document.body.classList.toggle("hidden");
		});
	}
	initBurgerMenu();

	// CART DRAWER

	function initCartDrawer() {
		const drawer = document.querySelector("[data-cart-drawer]");
		if (!drawer) return;

		const body = drawer.querySelector("[data-cart-drawer-body]");
		const foot = drawer.querySelector("[data-cart-drawer-foot]");

		function open() {
			drawer.classList.add("is-open");
			drawer.setAttribute("aria-hidden", "false");
			document.body.classList.add("hidden");
		}

		function close() {
			drawer.classList.remove("is-open");
			drawer.setAttribute("aria-hidden", "true");
			document.body.classList.remove("hidden");
		}

		function clearOrphanGifts() {
			const json = { "Content-Type": "application/json", Accept: "application/json" };
			fetch(window.Shopify.routes.root + "cart.js", { headers: json })
				.then(function (response) { return response.json(); })
				.then(function (cart) {
					const hasPlan = (cart.items || []).some(function (item) {
						return item.selling_plan_allocation;
					});
					if (hasPlan) return;

					const updates = {};
					(cart.items || []).forEach(function (item) {
						if (item.properties && item.properties._gift_with_subscription) {
							updates[item.key] = 0;
						}
					});
					if (!Object.keys(updates).length) return;

					return fetch(window.Shopify.routes.root + "cart/update.js", {
						method: "POST",
						headers: json,
						body: JSON.stringify({ updates: updates }),
					}).then(function () { return refresh(); });
				})
				.catch(function () { });
		}

		function setCount(value) {
			const badge = document.querySelector("[data-cart-count]");
			if (!badge) return;
			badge.textContent = value;
			if (value > 0) badge.removeAttribute("hidden");
			else badge.setAttribute("hidden", "hidden");
		}

		// The drawer is redrawn from the section Shopify renders, so its
		// markup stays the work of one snippet rather than being rebuilt
		// here. The count comes from the cart itself, which answers even when
		// the section request does not.
		function refresh() {
			const counted = fetch(window.Shopify.routes.root + "cart.js", {
				headers: { Accept: "application/json" },
			})
				.then(function (response) { return response.json(); })
				.then(function (cart) { setCount(cart.item_count); })
				.catch(function () { });

			const drawn = fetch(
				window.Shopify.routes.root + "?sections=cart-drawer",
				{ headers: { Accept: "application/json" } }
			)
				.then(function (response) {
					if (!response.ok) throw new Error("sections " + response.status);
					return response.json();
				})
				.then(function (data) { draw(data["cart-drawer"]); });

			return Promise.all([counted, drawn]);
		}

		function draw(markup) {
			if (!markup) throw new Error("empty");
			const parsed = new DOMParser().parseFromString(markup, "text/html");
			const nextBody = parsed.querySelector("[data-cart-drawer-body]");
			const nextFoot = parsed.querySelector("[data-cart-drawer-foot]");
			if (nextBody && body) body.innerHTML = nextBody.innerHTML;
			if (nextFoot && foot) foot.innerHTML = nextFoot.innerHTML;
			// Gifts whose subscription has gone are withheld from the
			// markup; clear them so the cart matches what is shown.
			if (body && body.querySelector("[data-cart-drawer-orphans]")) {
				clearOrphanGifts();
			}
		}

		// Shopify takes about a second to change a line, so the stepper
		// shows the new count at once and fades the prices until the cart
		// answers. The cart is told once the presses pause, so a quick run
		// of them is one request, and that request brings the redrawn drawer
		// back with it instead of asking for it afterwards.
		//
		// The stepper changes only its own line. A gift is a line of its own
		// at one, granted once per subscription, so it is held at one here
		// too in case anything else in the cart ever raised it.
		const waiting = {};
		let sent = 0;

		function sendQuantity(key, quantity) {
			const json = { "Content-Type": "application/json", Accept: "application/json" };
			const request = ++sent;

			function post(url, payload) {
				payload.sections = "cart-drawer";
				return fetch(window.Shopify.routes.root + url, {
					method: "POST",
					headers: json,
					body: JSON.stringify(payload),
				}).then(function (response) {
					if (!response.ok) throw new Error("cart " + response.status);
					return response.json();
				});
			}

			post("cart/change.js", { id: key, quantity: quantity })
				.then(function (cart) {
					const updates = {};
					(cart.items || []).forEach(function (item) {
						if (item.properties && item.properties._gift_with_subscription && item.quantity > 1) {
							updates[item.key] = 1;
						}
					});
					if (!Object.keys(updates).length) return cart;
					return post("cart/update.js", { updates: updates });
				})
				.then(function (cart) {
					// A later press is still on its way; its answer redraws.
					if (request !== sent || Object.keys(waiting).length) return;
					setCount(cart.item_count);
					draw(cart.sections && cart.sections["cart-drawer"]);
				})
				.catch(function () { return refresh(); })
				.catch(function () { })
				.then(function () {
					if (request === sent && !Object.keys(waiting).length) {
						drawer.classList.remove("is-updating");
					}
				});
		}

		document.addEventListener("click", function (event) {
			const trigger = event.target.closest("[data-cart-drawer-open]");
			if (trigger) {
				event.preventDefault();
				open();
				refresh().catch(function () {
					window.location.href = trigger.href;
				});
				return;
			}

			if (event.target.closest("[data-cart-drawer-close]")) {
				event.preventDefault();
				close();
				return;
			}

			// Removing a line keeps the drawer open rather than following the
			// link to the cart page.
			const remove = event.target.closest("[data-cart-drawer-remove]");
			if (remove) {
				event.preventDefault();
				const key = remove.getAttribute("data-line-key");
				if (!key) return;

				const json = { "Content-Type": "application/json", Accept: "application/json" };

				// Gifts are granted by the subscription, so removing it takes
				// them with it — otherwise they are left behind with no way
				// to remove them, since a gift has no remove button of its own.
				fetch(window.Shopify.routes.root + "cart.js", { headers: json })
					.then(function (response) { return response.json(); })
					.then(function (cart) {
						const updates = {};
						updates[key] = 0;

						const line = (cart.items || []).find(function (item) {
							return item.key === key;
						});
						if (line && line.selling_plan_allocation) {
							(cart.items || []).forEach(function (item) {
								if (item.properties && item.properties._gift_with_subscription) {
									updates[item.key] = 0;
								}
							});
						}

						return fetch(window.Shopify.routes.root + "cart/update.js", {
							method: "POST",
							headers: json,
							body: JSON.stringify({ updates: updates }),
						});
					})
					.then(function () { return refresh(); })
					.catch(function () { window.location.href = remove.href; });
				return;
			}

			const change = event.target.closest("[data-qty-change]");
			if (change) {
				event.preventDefault();
				const stepper = change.closest("[data-cart-drawer-qty]");
				const key = stepper && stepper.getAttribute("data-line-key");
				const step = parseInt(stepper && stepper.getAttribute("data-step"), 10) || 1;
				const current = parseInt(stepper && stepper.getAttribute("data-quantity"), 10);
				if (!key || isNaN(current)) return;

				// A plan line moves in whole plans and never below one of them.
				const quantity = current + step * parseInt(change.getAttribute("data-qty-change"), 10);
				if (quantity < step) return;

				stepper.setAttribute("data-quantity", quantity);
				// Shown in plans, as the markup shows it; the cart counts bags.
				stepper.querySelector("[data-qty-value]").textContent = quantity / step;
				stepper.querySelector("[data-qty-change='-1']").disabled = quantity <= step;
				const line = stepper.closest(".cart-drawer__line");
				if (line) line.classList.add("is-updating");
				drawer.classList.add("is-updating");

				clearTimeout(waiting[key]);
				waiting[key] = setTimeout(function () {
					delete waiting[key];
					sendQuantity(key, quantity);
				}, 250);
			}
		});

		document.addEventListener("keydown", function (event) {
			if (event.key === "Escape" && drawer.classList.contains("is-open")) close();
		});

		// Adding to the cart opens the drawer, so the product form hands over
		// here instead of sending the visitor to the cart page.
		document.addEventListener("cart:added", function () {
			open();
			refresh().catch(function () {
				// Showing a cart that is out of date would be worse than
				// leaving the page, so hand over to the cart itself.
				window.location.href = window.Shopify.routes.root + "cart";
			});
		});
	}
	initCartDrawer();

	// FLAVOUR PICKER

	function initVariantPicker() {
		const section = document.querySelector("[data-product-section]");
		if (!section) return;

		const sectionId = section.getAttribute("data-product-section");

		// Each flavour links to its own variant URL, which works on its own.
		// Fetching that URL instead and swapping the section in keeps the
		// page where it is, and falls back to following the link.
		section.addEventListener("click", function (event) {
			const link = event.target.closest(".flavours__link");
			if (!link || link.classList.contains("is-active")) return;
			if (event.metaKey || event.ctrlKey || event.shiftKey) return;

			event.preventDefault();
			section.classList.add("is-loading");

			fetch(link.href + (link.href.indexOf("?") === -1 ? "?" : "&") +
				"section_id=" + sectionId, { headers: { Accept: "text/html" } })
				.then(function (response) {
					if (!response.ok) throw new Error("section");
					return response.text();
				})
				.then(function (markup) {
					const parsed = new DOMParser().parseFromString(markup, "text/html");
					const next = parsed.querySelector("[data-product-section]");
					if (!next) throw new Error("missing");
					section.innerHTML = next.innerHTML;
					window.history.replaceState({}, "", link.href);
					section.classList.remove("is-loading");
					// Scripts set through innerHTML never run, and the product
					// form's own script is what sends a plan, its gifts and the
					// drawer event; without it the form posts a one-time purchase
					// to /cart. Swapping each one for a fresh element runs it.
					section.querySelectorAll("script").forEach(function (old) {
						const script = document.createElement("script");
						Array.prototype.forEach.call(old.attributes, function (attribute) {
							script.setAttribute(attribute.name, attribute.value);
						});
						script.textContent = old.textContent;
						old.replaceWith(script);
					});
					// The gallery and the plan script live inside the markup
					// that was just replaced, so they are started again.
					initProductGallery();
					initCounter();
					initAccordion(section);
				})
				.catch(function () {
					window.location.href = link.href;
				});
		});
	}
	initVariantPicker();

	// SMOOTH SCROLL

	function initSmoothScroll() {
		const links = document.querySelectorAll(".js_scroll_down");
		if (!links.length) return;

		links.forEach(function (link) {
			link.addEventListener("click", function (e) {
				e.preventDefault();
				const targetId = link.getAttribute("href");
				const target = document.querySelector(targetId);
				if (!target) return;

				window.scrollTo({
					top: target.getBoundingClientRect().top + window.pageYOffset,
					behavior: "smooth",
				});
			});
		});
	}
	initSmoothScroll();

	// ACCORDION

	// Takes the element to look inside, so a section swapped in later can be
	// wired up on its own without binding the rest of the page a second time.
	function initAccordion(root) {
		const accordions = (root || document).querySelectorAll("[data-accordion]");
		if (!accordions.length) return;

		accordions.forEach(function (accordion) {
			const items = accordion.querySelectorAll("[data-accordion-item]");
			if (!items.length) return;

			items.forEach(function (item) {
				const trigger = item.querySelector("[data-accordion-trigger]");
				if (!trigger) return;

				trigger.addEventListener("click", function (e) {
					e.preventDefault();
					const isActive = item.classList.contains("is-active");

					items.forEach(function (otherItem) {
						otherItem.classList.remove("is-active");
					});

					if (!isActive) {
						item.classList.add("is-active");
					}
				});
			});
		});
	}
	initAccordion();

	// TABS

	function initTabs() {
		const tabContainers = document.querySelectorAll("[data-tabs]");
		if (!tabContainers.length) return;

		tabContainers.forEach(function (container) {
			const buttons = container.querySelectorAll("[data-tab-btn]");
			const items = container.querySelectorAll("[data-tab-item]");
			if (!buttons.length || !items.length) return;

			buttons[0].classList.add("is-active");
			items[0].classList.add("is-active");

			buttons.forEach(function (button, index) {
				button.addEventListener("click", function () {
					buttons.forEach(function (btn) {
						btn.classList.remove("is-active");
					});
					items.forEach(function (item) {
						item.classList.remove("is-active");
					});

					button.classList.add("is-active");
					if (items[index]) items[index].classList.add("is-active");
				});
			});
		});
	}
	initTabs();

	// FANCYBOX

	function initFancybox() {
		if (typeof Fancybox === "undefined") return;

		const fancyboxInline = document.querySelector("[data-fancybox-inline]");
		if (fancyboxInline) {
			Fancybox.bind("[data-fancybox-inline]", {
				closeButton: false,
			});
		}

		const fancyboxGeneral = document.querySelector("[data-fancybox]");
		if (fancyboxGeneral) {
			Fancybox.bind("[data-fancybox]", {});
		}
	}
	initFancybox();

	// HERO SLIDER

	function initBannerSlider() {
		const slider = document.querySelector("[data-banner-slider]");
		if (!slider || typeof Swiper === "undefined") return;

		const speed = 700;
		const revealAt = 380;
		let timer = 0;

		function hide() {
			window.clearTimeout(timer);
			slider.querySelectorAll("[data-reveal]").forEach(function (item) {
				item.classList.remove("is-revealed");
			});
			timer = window.setTimeout(reveal, revealAt);
		}

		function reveal() {
			window.clearTimeout(timer);
			const slide = slider.querySelector(".swiper-slide-active");
			if (!slide) return;
			slide.querySelectorAll("[data-reveal]").forEach(function (item, index) {
				const delay = parseInt(item.dataset.revealDelay, 10) || index * 90;
				item.style.setProperty("--reveal-delay", delay + "ms");
				item.classList.add("is-revealed");
			});
		}

		new Swiper(slider, {
			slidesPerView: 1,
			speed: speed,
			loop: true,
			// autoplay: {
			// 	delay: 6000,
			// 	disableOnInteraction: false,
			// },
			navigation: {
				nextEl: ".banner__next",
				prevEl: ".banner__prev",
			},
			on: {
				afterInit: reveal,
				slideChangeTransitionStart: hide,
				slideChangeTransitionEnd: reveal,
			},
		});
	}
	initBannerSlider();

	// SWIPER SLIDER

	function initReviewsSlider() {
		const slider = document.querySelector(".reviews__slider");
		if (!slider || typeof Swiper === "undefined") return;

		new Swiper(".reviews__slider", {
			spaceBetween: 12,
			speed: 800,
			loop: true,
			centeredSlides: true,
			slidesPerView: "auto",
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".reviews__next",
				prevEl: ".reviews__prev",
			},
			breakpoints: {
				768: {
					spaceBetween: 24,
				},
			},
		});
	}
	initReviewsSlider();

	// ARTICLES SLIDER

	function initLearnSlider() {
		const slider = document.querySelector(".learn__slider");
		if (!slider || typeof Swiper === "undefined") return;

		new Swiper(".learn__slider", {
			spaceBetween: 12,
			speed: 800,
			loop: true,
			centeredSlides: true,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".learn__next",
				prevEl: ".learn__prev",
			},
			breakpoints: {
				768: {
					spaceBetween: 20,
				},
			},
		});
	}
	initLearnSlider();

	// COMMUNITY SLIDER

	function initMovementSlider() {
		const slider = document.querySelector(".movement__slider");
		if (!slider || typeof Swiper === "undefined") return;

		// No autoplay: the slides hold videos, so advancing on a timer would
		// interrupt whatever the visitor is watching.
		new Swiper(slider, {
			spaceBetween: 12,
			speed: 800,
			loop: true,
			centeredSlides: true,
			slidesPerView: "auto",
			breakpoints: {
				768: {
					spaceBetween: 20,
				},
			},
		});
	}
	initMovementSlider();

	// COMMUNITY VIDEO CARDS

	function initMovementVideo() {
		const slider = document.querySelector(".movement__slider");
		if (!slider || !slider.swiper) return;

		const swiper = slider.swiper;
		const cards = slider.querySelectorAll("[data-video]");
		if (!cards.length) return;

		let wanted = -1;

		function sync() {
			const active = swiper.slides[swiper.activeIndex];
			cards.forEach(function (card) {
				const video = card.querySelector("[data-video-player]");
				if (card.closest(".swiper-slide") === active && swiper.realIndex === wanted) {
					if (!video.getAttribute("src")) video.setAttribute("src", video.dataset.src);
					if (video.paused) video.play().catch(function () { });
					return;
				}
				if (!video.paused) video.pause();
			});
		}

		cards.forEach(function (card) {
			const video = card.querySelector("[data-video-player]");
			const soundBtn = card.querySelector("[data-video-sound]");
			if (!video) return;

			card.addEventListener("click", function () {
				const slide = card.closest(".swiper-slide");
				const index = Number(slide.getAttribute("data-swiper-slide-index"));
				if (slide !== swiper.slides[swiper.activeIndex]) {
					wanted = index;
					swiper.slideToLoop(index);
					return;
				}
				wanted = video.paused ? index : -1;
				sync();
			});

			video.addEventListener("play", function () {
				card.classList.add("is-playing");
			});

			video.addEventListener("pause", function () {
				card.classList.remove("is-playing");
			});

			if (!soundBtn) return;
			soundBtn.addEventListener("click", function (event) {
				event.stopPropagation();
				video.muted = !video.muted;
				card.classList.toggle("is-sound", !video.muted);
				soundBtn.setAttribute("aria-label", video.muted ? "Unmute video" : "Mute video");
			});
		});

		swiper.on("slideChange", sync);
		swiper.on("slideChangeTransitionEnd", sync);
		swiper.on("loopFix", sync);
	}
	initMovementVideo();

	// CUSTOM SELECT

	function initSelect() {
		const selects = document.querySelectorAll(".js_select");
		if (!selects.length || typeof Choices === "undefined") return;

		selects.forEach(function (select) {
			new Choices(select, {
				searchEnabled: false,
				shouldSort: false,
				allowHTML: true,
				itemSelectText: "",
			});
		});
	}
	initSelect();

	// QUANTITY COUNTER

	function initCounter() {
		const counters = document.querySelectorAll("[data-counter]");
		if (!counters.length) return;

		counters.forEach(function (counter) {
			const input = counter.querySelector("[data-counter-input]");
			const minus = counter.querySelector("[data-counter-minus]");
			const plus = counter.querySelector("[data-counter-plus]");
			if (!input || !minus || !plus) return;

			function setValue(value) {
				input.value = value < 1 ? 1 : value;
			}

			minus.addEventListener("click", function () {
				setValue(parseInt(input.value, 10) - 1);
			});

			plus.addEventListener("click", function () {
				setValue(parseInt(input.value, 10) + 1);
			});

			input.addEventListener("input", function () {
				input.value = input.value.replace(/\D/g, "");
			});

			input.addEventListener("blur", function () {
				setValue(parseInt(input.value, 10) || 1);
			});
		});
	}
	initCounter();

	// PRODUCT GALLERY

	function initProductGallery() {
		const gallery = document.querySelector("[data-product-gallery]");
		if (!gallery || typeof Swiper === "undefined") return;

		const sliderEl = gallery.querySelector("[data-product-slider]");
		const thumbs = gallery.querySelectorAll("[data-product-thumb]");
		if (!sliderEl || !thumbs.length) return;

		const slider = new Swiper(sliderEl, {
			speed: 600,
			slidesPerView: 1,
		});

		thumbs.forEach(function (thumb, index) {
			thumb.addEventListener("click", function () {
				slider.slideTo(index);
			});
		});

		slider.on("slideChange", function () {
			thumbs.forEach(function (thumb) {
				thumb.classList.remove("is-active");
			});
			if (thumbs[slider.activeIndex]) thumbs[slider.activeIndex].classList.add("is-active");
		});
	}
	initProductGallery();

	// SELLING PLAN

	function initSellingPlan() {
		const target = document.querySelector("[data-selling-plan]");
		if (!target) return;

		const options = document.querySelectorAll("[name='purchase_option']");
		if (!options.length) return;

		options.forEach(function (option) {
			option.addEventListener("change", function () {
				target.value = option.value;
			});
		});
	}
	initSellingPlan();

	// PARALLAX ON SCROLL

	function initParallax() {
		const items = document.querySelectorAll("[data-parallax]");
		if (!items.length) return;
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

		function update() {
			const height = window.innerHeight;
			items.forEach(function (item) {
				const amplitude = parseFloat(item.dataset.parallax);
				if (!amplitude) return;
				const box = item.getBoundingClientRect();
				let progress = (box.top + box.height / 2 - height / 2) / height;
				if (progress > 1) progress = 1;
				if (progress < -1) progress = -1;
				item.style.setProperty("--parallax", (progress * amplitude).toFixed(2) + "px");
			});
		}

		window.addEventListener("scroll", update, { passive: true });
		window.addEventListener("resize", update);
		window.addEventListener("load", update);
		update();
	}
	initParallax();

	// TIMELINE PROGRESS ON SCROLL

	function initTimeline() {
		const timelines = document.querySelectorAll("[data-timeline]");
		if (!timelines.length) return;

		const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		timelines.forEach(function (timeline) {
			const items = Array.prototype.slice.call(timeline.querySelectorAll("[data-timeline-item]"));
			if (!items.length) return;

			const last = items.length - 1;
			const stepDelay = 300;
			let current = -1;
			let target = 0;
			let timer = 0;
			let ticking = false;

			function setCurrent(index) {
				if (index === current) return;
				current = index;
				items.forEach(function (item, i) {
					item.classList.toggle("is-done", i < index);
					item.classList.toggle("is-current", i === index);
				});
			}

			function stop() {
				window.removeEventListener("scroll", onScroll);
				window.removeEventListener("resize", onScroll);
				window.removeEventListener("load", onScroll);
			}

			function pump() {
				timer = 0;
				if (current >= target) return;
				setCurrent(current + 1);
				if (current === last) {
					stop();
					return;
				}
				if (current < target) timer = window.setTimeout(pump, stepDelay);
			}

			function update() {
				ticking = false;
				const line = window.innerHeight * 0.62;
				let index = 0;
				items.forEach(function (item, i) {
					if (item.getBoundingClientRect().top <= line) index = i;
				});
				if (index > target) target = index;
				if (!timer) pump();
			}

			function onScroll() {
				if (ticking) return;
				ticking = true;
				window.requestAnimationFrame(update);
			}

			if (reduced) {
				setCurrent(last);
				return;
			}

			window.addEventListener("scroll", onScroll, { passive: true });
			window.addEventListener("resize", onScroll);
			window.addEventListener("load", onScroll);
			update();
		});
	}
	initTimeline();

	// COUNTDOWN TIMER

	function initCountdown() {
		const timers = document.querySelectorAll("[data-countdown]");
		if (!timers.length) return;

		const second = 1000;
		const minute = second * 60;
		const hour = minute * 60;
		const day = hour * 24;

		timers.forEach(function (timer) {
			const deadline = Date.parse(timer.dataset.countdown);
			if (isNaN(deadline)) return;

			const cells = timer.querySelectorAll("[data-countdown-unit]");
			if (!cells.length) return;

			function pad(value) {
				return value < 10 ? "0" + value : String(value);
			}

			function render() {
				let left = deadline - Date.now();
				if (left < 0) left = 0;

				const values = {
					days: Math.floor(left / day),
					hours: Math.floor((left % day) / hour),
					mins: Math.floor((left % hour) / minute),
					secs: Math.floor((left % minute) / second)
				};

				cells.forEach(function (cell) {
					const value = values[cell.dataset.countdownUnit];
					if (value === undefined) return;
					const text = pad(value);
					if (cell.textContent !== text) cell.textContent = text;
				});

				return left;
			}

			function tick() {
				if (render() <= 0) return;
				window.setTimeout(tick, second - (Date.now() % second));
			}

			tick();
		});
	}
	initCountdown();

	// FADE UP REVEAL ON SCROLL

	function initReveal() {
		const items = document.querySelectorAll("[data-reveal]");
		if (!items.length) return;

		function show(item) {
			item.classList.add("is-revealed");
		}

		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
			items.forEach(show);
			return;
		}

		const observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.target.hasAttribute("data-reveal-once")) {
					if (!entry.isIntersecting) return;
					show(entry.target);
					observer.unobserve(entry.target);
					return;
				}
				entry.target.classList.toggle("is-revealed", entry.isIntersecting);
			});
		}, { rootMargin: "0px 0px -8% 0px", threshold: 0.15 });

		items.forEach(function (item) {
			if (item.closest(".swiper-slide")) return;
			if (item.closest("[data-tab-item]:not(.is-active)")) {
				show(item);
				return;
			}
			const delay = parseInt(item.dataset.revealDelay, 10) || 0;
			item.style.setProperty("--reveal-delay", delay + "ms");
			observer.observe(item);
		});
	}
	initReveal();

	// LAZY VIDEOS AND POSTERS

	// Autoplay videos (data-lazy-video) and video posters (data-poster) far
	// down the page are fetched only as they near the screen, not with it.
	// A video in a slider is watched through its slider, since slides parked
	// off to the side never come into view on their own.
	function initLazyMedia() {
		const videos = document.querySelectorAll("video[data-lazy-video], video[data-poster]");
		if (!videos.length) return;

		const groups = new Map();
		videos.forEach(function (video) {
			const target = video.closest(".swiper") || video;
			if (!groups.has(target)) groups.set(target, []);
			groups.get(target).push(video);
		});

		function load(video) {
			if (video.dataset.poster) {
				video.setAttribute("poster", video.dataset.poster);
				video.removeAttribute("data-poster");
			}
			if (video.hasAttribute("data-lazy-video") && !video.getAttribute("src")) {
				video.setAttribute("src", video.dataset.src);
				video.play().catch(function () { });
			}
		}

		if (!("IntersectionObserver" in window)) {
			videos.forEach(load);
			return;
		}

		const observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				groups.get(entry.target).forEach(load);
				observer.unobserve(entry.target);
			});
		}, { rootMargin: "400px 0px" });

		groups.forEach(function (list, target) {
			observer.observe(target);
		});
	}
	initLazyMedia();
});
